import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsCustomFiltersRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-custom-filters',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
	exact: true,
};
